export default __webpack_public_path__ + "static/media/8.a6fc2b21.png";